import React from 'react';

function SignRedComp(props) {
  return (
    <p className='w-full bg-white-400 font-semibold p-2'>
      {props.label} : {props.number}
    </p>
  );
}

export default SignRedComp;
